import { i18nTranslationHelper } from '@/i18n'
import theme from '@/presentation/assets/styles/theme'
import { Fragment } from 'react'
import { isCollapsibleMenu, MenuSectionDefinition } from './types'
import { MenuItemCollapsible } from './menu-item-collapsible'
import { MenuItemUnified } from './menu-item-unified'
import { MenuVariant } from './types'
import { Divider, ListItem, Typography } from '@mui/material'

interface MenuRendererProps {
  variant: MenuVariant
  section: MenuSectionDefinition

  handleClose: () => void
}

export function MenuRenderer({ variant, section, handleClose }: MenuRendererProps) {
  const t = i18nTranslationHelper.getTComponents

  return (
    <Fragment>
      <Divider component="li" sx={{ my: 0.5 }} />

      {section.titleKey && (
        <ListItem>
          <Typography variant="caption" color="common.black">
            {t(section.titleKey)}
          </Typography>
        </ListItem>
      )}

      {section.items
        .filter(item => item.isVisible)
        .map(item => {
          if (isCollapsibleMenu(item)) {
            return (
              <MenuItemCollapsible
                key={item.key}
                variant={variant}
                icon={item.icon}
                title={t(item.titleKey)}
              >
                {item.items
                  .filter(subItem => subItem.isVisible)
                  .map(subItem => (
                    <MenuItemUnified
                      key={subItem.key}
                      variant={variant}
                      route={subItem.route}
                      icon={subItem.icon}
                      availableIn={subItem.availableIn}
                      className={subItem.className}
                      onClick={subItem.onClick}
                      onClose={handleClose}
                      sx={variant === 'desktop' ? { pl: theme.spacing(7) } : {}}
                    />
                  ))}
              </MenuItemCollapsible>
            )
          }

          return (
            <MenuItemUnified
              key={item.key}
              variant={variant}
              route={item.route}
              icon={item.icon}
              availableIn={item.availableIn}
              className={item.className}
              onClick={item.onClick}
              onClose={handleClose}
            />
          )
        })}
    </Fragment>
  )
}
